var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInvitedCircle2Color24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.944 12.004a.277.277 0 00.067-.242.295.295 0 00-.133-.205 4.509 4.509 0 00-2.415-.712 4.558 4.558 0 00-4.358 3.235.302.302 0 00.29.386h5.227a.296.296 0 00.296-.247 4.866 4.866 0 011.026-2.215zM9.33 10.24a2.867 2.867 0 100-5.734 2.867 2.867 0 000 5.735zm6.339.906a3.924 3.924 0 100 7.847 3.924 3.924 0 000-7.847zm0 6.64a2.717 2.717 0 112.716-2.716 2.723 2.723 0 01-2.716 2.717z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.876 14.466h-.453a.15.15 0 01-.15-.15v-.604a.604.604 0 10-1.208 0v1.358a.603.603 0 00.604.604h1.207a.604.604 0 100-1.207z"
  })));
}
export default SvgIconInvitedCircle2Color24;